import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';
import { SelectLineModelGet, SelectLineModelParams } from '../select-line-model.component';
import { Item } from '@app/core/components/listbox/listbox.component';
import { SelectLineProductsParams } from '../../select-line-products/select-line-products.component';

@Component({
    selector: 'tt-select-line-model-view',
    templateUrl: './select-line-model-view.component.html',
    styleUrls: ['./select-line-model-view.component.css'],
})
export class SelectLineModelViewComponent {
    heading = '';

    params: SelectLineModelParams;

    constructor(private state: StateService) {
        this.params = state.getStateParams() as unknown as SelectLineModelParams;
    }

    public setHeading(event: SelectLineModelGet) {
        this.heading = event.webpage_heading;
    }

    public onSubmit(event: SelectLineProductsParams) {
        this.state.go('orderlineps', event);
        // console.log(event);
    }
}
